module.exports = __webpack_public_path__ + "files/5e1e7857721a6863d43f5ab04649d4cd.png";